import React from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import type { SyntaxHighlighterProps } from "react-syntax-highlighter";
import {
  atomOneDark as darkTheme,
  lightfair as lightTheme,
} from "react-syntax-highlighter/dist/cjs/styles/hljs";
import { getTypographyClassName, useThemeContext } from "@appsmith/wds-theming";

export const CodeBlock = (props: SyntaxHighlighterProps) => {
  const theme = useThemeContext();

  return (
    <SyntaxHighlighter
      className={getTypographyClassName("body") + " wds-codeblock"}
      {...props}
      // Additive: callers may supply their own syntax style object (e.g. the
      // WDS-token-mapped style used by the Anvil Code widget, which follows
      // theme + dark mode via CSS custom properties). Without an explicit
      // style, the stock hljs themes per color mode are preserved.
      style={
        props.style ?? (theme.colorMode === "dark" ? darkTheme : lightTheme)
      }
      useInlineStyles
    >
      {props.children}
    </SyntaxHighlighter>
  );
};
